import { Title } from "@common/index";

// TODO(content): real support channels + FAQ per Q13
export const SupportPage = () => {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10 text-primary">
            <Title>Support</Title>
            <p className="text-base mt-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Need a
                hand? Our team is here to help with orders, membership, and
                anything else.
            </p>
            <p className="text-base mt-4">
                Contact us at support@nara.com.
            </p>
        </div>
    );
};
